import { Coffee, Clock } from "lucide-react";

const fmtBreak = (secs) => {
  const m = Math.floor(secs / 60), s = secs % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};
const fmtExam = (secs) => {
  if (secs == null) return "--:--:--";
  const h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

export const BreakScreen = ({ es, breakLeft, timeLeft, onResume }) => {
  const over = breakLeft != null && breakLeft <= 0;
  const sealedEnd = (es.section - 1) * 60;
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4" data-testid="break-screen">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-xl shadow-[0_4px_12px_rgba(0,0,0,0.05)] p-8 text-center">
        <Coffee className="w-10 h-10 text-blue-700 mx-auto mb-4" strokeWidth={1.5} />
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">
          Section {es.section - 1} complete
        </h1>
        <p className="mt-2 text-sm text-slate-500 leading-relaxed">
          You may take an optional <strong>10-minute break</strong>. Your exam clock is paused while the
          break timer runs. Questions 1–{sealedEnd} are sealed — as on the real PMP exam, you can't return to them.
        </p>
        {!over ? (
          <>
            <div data-testid="break-countdown" className="mt-6 font-mono text-4xl font-semibold text-slate-900">
              {breakLeft == null ? "10:00" : fmtBreak(breakLeft)}
            </div>
            <div className="text-xs text-slate-400 mt-1">break time remaining · exam clock paused</div>
          </>
        ) : (
          <div data-testid="break-overage-warning" className="mt-6 rounded-lg border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700 flex items-center justify-center gap-2">
            <Clock className="w-4 h-4 shrink-0" />
            Break time is up — your exam clock is running ({fmtExam(timeLeft)} left)
          </div>
        )}
        <button
          data-testid="resume-exam-btn"
          onClick={onResume}
          className="mt-8 w-full bg-blue-700 hover:bg-blue-800 text-white font-medium py-2.5 rounded-lg transition-colors"
        >
          Begin Section {es.section}
        </button>
        <p className="mt-3 text-xs text-slate-400 leading-relaxed">
          Time beyond 10 minutes is deducted from your remaining exam time.
        </p>
      </div>
    </div>
  );
};
